angular.module('impactx.invoice').controller('InvoiceItemComplaintDialog', [
    'dataGen',
    'ConfirmationService',
    'TranslationService',
    'blhId',
    'refId',
    'refType',
    'item',
    '$scope',
    '$mdDialog',
    InvoiceItemComplaintDialog
]);

function InvoiceItemComplaintDialog(dataGen, ConfirmationService, TranslationService, blhId, refId, refType,
                                item, $scope, $mdDialog) {
    var self = this;

    self.saveLabel = TranslationService.get('save');
    self.abort = TranslationService.get('abort');
    $scope.item = item;
    $scope.type = refType;

    dataGen.getData($scope, {id: blhId, refId: refId, refName: refType}, "/invoice/complaint/item/view");

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.save = function () {
        dataGen.postAsForm({}, {item: $scope.data}, "/invoice/complaint/item/save").then(function () {
            $mdDialog.hide();
        });
    };

}